import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import {
  QualityStandard,
  WeightUnit,
  ShippingCollectiveDetailItem,
  ShippingRecordCollectiveRegisterItem,
  ShippingDestinationList,
  ShippingDestinations,
  SelectCropAndPlantingInShippingRecord,
  ShippingDestination
} from "@/types/Component";
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import QualityStandardSelectModal from '@/assets/common/Modal/ItemSelectModal/QualityStandardSelectModal/QualityStandardSelectModal.vue'
import moment from 'moment';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import { QualityStandardResponse, WeightUnitResponse } from "@/types/APIResponse"
import ShippingDestinationSelectModal from "@/assets/common/Modal/ItemSelectModal/ShippingDestinationSelectModal/ShippingDestinationSelectModal.vue";
import SelectPlantingCollectiveShipping from '@/components/Record/SelectPlantingCollectiveShipping/SelectPlantingCollectiveShipping.vue'
import axios, { AxiosRequestConfig } from 'axios';
import CollectiveShippingSplitModal from '@/components/AdditionalFunction/CollectiveShippingSplitModal/CollectiveShippingSplitModal.vue';


type ShippingRecordCollectivePostModel = {
  shipping_destination_id: string
  isValidationNeeded: boolean;
  shipping_record_collective: {
    shipping_date: string;
    crop_id: string | null;
    planting_id: string | null;
    quality_standard_id: string | null;
    quantity: number | null;
    weight_unit_id: string | null;
    amount: number | null;
    unit_price: number | null;
    memo: string | null;
    error_message: string | null
  }[];
}

type QualityStandards = {
  qualityStandards: QualityStandard[];
}

type WeightUnits = {
  weightUnits: WeightUnit[];
}
@Component({
  components: {
    ShippingDestinationSelectModal,
    SelectPlantingCollectiveShipping,
    CollectiveShippingSplitModal,
    EditModal,
    QualityStandardSelectModal
  }
})
export default class ShippingCollectiveRegisterList extends Vue {
  private apiServerBaseUrl = process.env.VUE_APP_API_URL_BASE
  @Prop({ default: false })
  private showShippingCollectiveRegister!: boolean;
  @Prop()
  private mode = ''
  @Prop()
  private shippingIds: string[] = []

  @Prop({ default: false })
  private readonly isRefresh!: boolean;

  private showSelectFromPlantingShipping = false
  private apiBaseUrl = '/admin/shipping_record_register_collective'
  private shippingDestinationList = [] as ShippingDestinationList[];
  private selectedDestinations: ShippingDestinations[] = []
  private selectedDestination: any = ''
  private selectedShippingTarget: {
    cropId: string | null;
    plantingId: string | null;
  } = {
      cropId: null,
      plantingId: null
    }

  private selectedTableShippingTarget: {
    cropId: string | null;
    plantingId: string | null;
  } = {
      cropId: null,
      plantingId: null
    }
  private isAutoCalc = true
  private headerTitle = ''
  private subTitle = '';
  private showDestinationModal = false
  private qualityStandards: QualityStandard[] = []
  private weightUnits: WeightUnit[] = []
  private defaultWeightUnit: WeightUnit = {
    id: null,
    name: 'kg',
    weightPerUnit: 1,
    isHidden: false
  }
  private defaultShippingRecordCollective: ShippingRecordCollectiveRegisterItem = {
    crop_id: '',
    crop_name: '',
    planting_id: '',
    planting_name: '',
    crop: {
      id: '',
      name: '',
      phonetic: '',
    },
    planting: {
      id: '', // 作付ID
      name: '', // 作付名
    },
    qualityStandards : [],
    shippingDestination: [],
    shippingRecordCollectiveDetailsItem: []
  }
  isSelectPlantingVisible = false
  isShippingTableDisable = true
  plantingDetailShowFlag = true
  selectedStartDate: string | Date = new Date();
  selectedEndDate: string | Date = new Date();
  private selectedDays = [] as string[]
  datesToAdd = [] as string[]
  private showQulaitySelect = false
  private commaSeparatedNames = ''
  currentIndex = 0
  showSelectTablePlantingShipping = false
  showSplitShippingModal = false
  shippingCollectiveRegisterId = ''
  selectedCollectiveShippingDetails: any = []
  plantingBasicUnitId = null
  // 編集モーダル
  private showEditModal = false
  private editModalBaseUrl = ''
  private isCollectiveRecordSaved = false
  private isValidationNeeded = true
  private isSplitRecordSave = false
  isSaveEditRecord = false
  disableFieldFlag= false
  isaddBtnFlag = false
  isDeleteBtnDisable =false
  private activeInput =''
  private plantingAgrifelds =[]
  private  selectAll= false
  private selectedItems = [] as string[]
  private selectedAgriFieldId= null
  isButtonDisabled = false;
  isCheckAllEnable = true;
  shippingChildId  = this.shippingIds
  isAgriFieldSave = false
  private selectedQualityStd : QualityStandard[] = []



  private shippingRecordCollective: ShippingRecordCollectiveRegisterItem = this.defaultShippingRecordCollective

  private today = moment(new Date()).format('YYYY-MM-DD')
  private shippingRecordCollectiveDestination: ShippingCollectiveDetailItem[] = [{
    shippingDestinationId: '',
    shippingDestinationName: '',
    shippingRecordCollectiveId: '',
    shippingDate: this.today,
    crop: null,
    planting: null,
    qualityStandardId: null,// 品質規格ID
    qualityStandardName: '', // 品質規格名
    quantity: null, // 数量
    weightUnitId: null, // 単位ID
    weightUnitName: this.defaultWeightUnit.name, // 単位名
    amount: null, // 金額
    unitPrice: null, // 単価
    memo: null, // 備考
    errorMessage: null,
    selectedWeightUnit: this.defaultWeightUnit,
    quantityCheck: false,
    yetSplit: false,
    isShipped:false,
    splitCount: null,
    splitPlantingId :  null,
    splitPlantingName :  null,
    shippingCollectiveSplitObjs :[]
  }]

   get isShippingCollectiveModalOpen():boolean{
       return(
        this.showSelectFromPlantingShipping ||
        this.showDestinationModal ||
        this.showSelectTablePlantingShipping ||
        this.showSplitShippingModal ||
        this.showQulaitySelect ||
        this.showEditModal
       )
    }

  @Watch("showShippingCollectiveRegister")
  handleShippingRecordModal() {
    if (this.mode === 'edit' && this.showShippingCollectiveRegister === true) {
      this.getShippingRecordCollectiveRegisterdata(this.shippingIds);
    }
    else {
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = []
    }
  }

  refreshCollectiveTable() {
    this.getShippingRecordCollectiveRegisterdata(this.shippingChildId);
    this.$emit('update:isRefresh', true);
  }

  created() {
    this.headerTitle = "出荷記録まとめて登録"
    this.getShippingDestination();
    this.getQualityStandards()
    this.getWeightUnits()
    const currentDate = new Date();
    this.selectedStartDate = moment(currentDate).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    this.selectedEndDate = moment(currentDate).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.shippingRecordCollective = Object.assign({}, this.defaultShippingRecordCollective)
  }

  addDestinationDetail() {
    if ((this.shippingRecordCollective.crop?.id !== '' || this.shippingRecordCollective.planting?.id !== '') && this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length === 0) {
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.push({
        shippingDestinationId: '',
        shippingDestinationName: '',
        shippingRecordCollectiveId: '',
        shippingDate: this.today,
        crop: {
          id: this.shippingRecordCollective.crop?.id ?? '',
          name: this.shippingRecordCollective.crop?.name ?? '',
          phonetic: ''
        },
        planting: {
          id: this.shippingRecordCollective.planting?.id ?? '',
          name: this.shippingRecordCollective.planting?.name ?? ''
        },
        qualityStandardId: null,// 品質規格ID
        qualityStandardName: '', // 品質規格名
        quantity: null, // 数量
        weightUnitId: null, // 単位ID
        weightUnitName: this.defaultWeightUnit.name, // 単位名
        amount: null, // 金額
        unitPrice: null, // 単価
        memo: null, // 備考
        errorMessage: null,
        selectedWeightUnit: this.defaultWeightUnit,
        quantityCheck: false,
        yetSplit: true,
        isShipped:false,
        splitCount: null,
        splitPlantingId : null,
        splitPlantingName : null,
        shippingCollectiveSplitObjs :[]
      })
    }
    else if (this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length > 0) {
      this.currentIndex = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length
      const previousItem = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length - 1];
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.push({
        shippingDestinationId: '',
        shippingDestinationName: '',
        shippingRecordCollectiveId: '',
        shippingDate: previousItem.shippingDate,
        crop: {
          id: previousItem.crop?.id ?? '',
          name: previousItem.crop?.name ?? '',
          phonetic: ''
        },
        planting: {
          id: previousItem.planting?.id ?  previousItem.planting?.id ?? "" : previousItem.splitPlantingId ?? "",
          name: previousItem.planting?.name ? previousItem.planting?.name ?? "" : previousItem.splitPlantingName ?? "",
        },
        qualityStandardId: null, // 品質規格ID
        qualityStandardName: '', // 品質規格名
        quantity: null, // 数量
        weightUnitId: null, // 単位ID
        weightUnitName: this.defaultWeightUnit.name, // 単位名
        amount: null, // 金額
        unitPrice: null, // 単価
        memo: null, // 備考
        errorMessage: null,
        selectedWeightUnit: this.defaultWeightUnit,
        quantityCheck: false,
        yetSplit: true,
        isShipped:false,
        splitCount: null,
        splitPlantingId : null,
        splitPlantingName : null,
        shippingCollectiveSplitObjs :[]
      });
    }
    else {
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.push({
        shippingDestinationId: '',
        shippingDestinationName: '',
        shippingRecordCollectiveId: '',
        shippingDate: this.today,
        crop: { id: '', name: '', phonetic: '' },
        planting: { id: '', name: '' },
        qualityStandardId: null,// 品質規格ID
        qualityStandardName: '', // 品質規格名
        quantity: null, // 数量
        weightUnitId: null, // 単位ID
        weightUnitName: this.defaultWeightUnit.name, // 単位名
        amount: null, // 金額
        unitPrice: null, // 単価
        memo: null, // 備考
        errorMessage: null,
        selectedWeightUnit: this.defaultWeightUnit,
        quantityCheck: false,
        yetSplit: true,
        isShipped:false,
        splitCount: null,
        splitPlantingId :  null,
        splitPlantingName :  null,
        shippingCollectiveSplitObjs :[]
      })
    }
    this.setDefaultWeightUnit();
    this.disableFieldFlag = true
    this.inputChanged()
  }

  @Watch('selectedDays')
  checkByDay() {
    const startDate = moment(this.selectedStartDate);
    const endDate = moment(this.selectedEndDate);
    const selectedDays = Array.from(new Set(this.selectedDays.map(day => parseInt(day, 10))));
    if (!startDate.isValid() || !endDate.isValid() || selectedDays.length === 0) {
      this.datesToAdd = [];
      this.$store.dispatch('doUpdateIsInputChanged', false);
      return;
    }
  
    const uniqueDates = new Set<string>();
    const totalDays = endDate.diff(startDate, 'days') + 1;
    for (let i = 0; i < totalDays; i++) {
      const currentDate = startDate.clone().add(i, 'days');
      const isoWeekday = currentDate.isoWeekday(); 
      if (selectedDays.includes(isoWeekday)) {
        uniqueDates.add(currentDate.format('YYYY-MM-DD')); 
      }
    }
    this.datesToAdd = Array.from(uniqueDates);
  }

  @Watch('shippingRecordCollective.shippingRecordCollectiveDetailsItem')
  selectAllDisable(){
    if(this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length > 0){
      const shippingDetails = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.find(item => 
        item.shippingRecordCollectiveId && item.isShipped === false
      );
      if (shippingDetails) {
        this.isCheckAllEnable = true;
      } else {
        this.isCheckAllEnable = false;
      }
    }
    else{
      this.isCheckAllEnable = false
    }
  }

  appendBulkShippingDetails() {
    if (this.shippingRecordCollective.shippingDestination == null || this.shippingRecordCollective.shippingDestination.length == 0) {
      alert("出荷先を選択してください。");
      return false;
    }
    if (!this.selectedDays.length) {
      alert("曜日を選択してください。");
      return false;
    }
    if (!this.selectedQualityStd?.length) {
      alert("出荷（品質・規格）を選択してください。");
      return false;
    }
    const existingRecords = new Set(
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map(
        (item) => `${item.shippingDate}-${item.qualityStandardId}`
      )
    );
    this.datesToAdd.forEach((date) => {
      const qualityStandardsForDate = this.getQualityStandardsForDate(date);
      if (!qualityStandardsForDate.length) return;
  
      qualityStandardsForDate.forEach((qualityStandard) => {
        const recordKey = `${date}-${qualityStandard.id}`;
        if (!existingRecords.has(recordKey)) {
          this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.push({
            shippingDestinationId: '',
            shippingDestinationName: '',
            shippingRecordCollectiveId: '',
            shippingDate: date,
            crop: {
              id: this.shippingRecordCollective.crop?.id ?? '',
              name: this.shippingRecordCollective.crop?.name ?? '',
              phonetic: ''
            },
            planting: {
              id: this.shippingRecordCollective.planting?.id ?? '',
              name: this.shippingRecordCollective.planting?.name ?? ''
            },
            qualityStandardId: qualityStandard.id,
            qualityStandardName: qualityStandard.name,
            quantity: null,
            weightUnitId: null,
            weightUnitName: 'kg',
            amount: null,
            unitPrice: null,
            memo: null,
            errorMessage: null,
            selectedWeightUnit:
              this.weightUnits.find(
                (item) =>
                  item.id == this.plantingBasicUnitId && !item.isHidden
              ) ?? this.defaultWeightUnit,
            quantityCheck: false,
            yetSplit: true,
            isShipped: false,
            splitCount: null,
            splitPlantingId: null,
            splitPlantingName: null,
            shippingCollectiveSplitObjs :[]
          });
          existingRecords.add(recordKey); 
        }
      });
    });
    this.currentIndex =
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length;
    this.setDefaultWeightUnit();
    this.inputChanged()
  }

// Helper method to fetch quality standards for a given date
getQualityStandardsForDate(date: string): QualityStandard[] {
  return this.selectedQualityStd.filter(
      (qs) => !qs.isHidden
  );
}


private commitQualityStandard(value: { id: string; name: string, isHidden:boolean }[]) {
  this.$store.dispatch('doUpdateIsInputChanged', false);
  const newQualityStandards: QualityStandard[] = value
      .filter(v => this.qualityStandards.find(w => w.id === v.id)) 
      .map(v => ({
          id: v.id,
          name: v.name,
          isHidden:v.isHidden
      })); 
   this.shippingRecordCollective.qualityStandards = [...newQualityStandards];
   this.selectedQualityStd = this.shippingRecordCollective.qualityStandards
   this.commaSeparatedNames = this.shippingRecordCollective.qualityStandards
    .filter((qualityStandard: QualityStandard) => !qualityStandard.isHidden) 
    .map((qualityStandard: QualityStandard) => qualityStandard.name) 
    .join(', '); 

}

  deleteDestinationDetail(sd: ShippingRecordCollectiveRegisterItem, index: number) {
    sd.shippingRecordCollectiveDetailsItem?.splice(index, 1);
    this.pastedRowIndex = null
    this.selectedRowIndex = null
    this.copiedRowIndex = null
    this.copiedRowData = null
    this.cutRowIndex = null
    this.isCut = false
    this.isaddBtnFlag = false
    if(sd.shippingRecordCollectiveDetailsItem.length ===0){
    this.currentIndex =0
    }
    this.inputChanged()
  }

  // 編集モーダル表示
  private editWeightUnits() {
    this.editModalBaseUrl = '/weight_units'
    this.showEditModal = true
  }

  private editQualityStandards() {
    this.editModalBaseUrl = '/quality_standards'
    this.showEditModal = true
  }

  //   // 編集モーダルからのコールバック
  private async updateItems(baseUrl: string) {
    switch (baseUrl) {
      case '/weight_units':
        this.getWeightUnits().then(() => {
          this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map(detail => {
            const selectedWeightUnit = this.weightUnits.find(weightUnit => weightUnit.id == detail.selectedWeightUnit?.id)
            detail.selectedWeightUnit = selectedWeightUnit ? selectedWeightUnit : this.defaultWeightUnit
          })
        })
        break
      case '/quality_standards':
        await this.getQualityStandards()
        break
    }
  }

  //   // 編集モーダルのクローズ
  private closeEditModal() {
    this.showEditModal = false
  }

  async saveRecord() {
      if (!this.validation()) {
        return false
      }
      const shippingrecordCollectiveDetails = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem
      .filter(detail => detail.quantity || detail.amount || detail.unitPrice || detail.memo)
      .map(destination => ({
        shipping_record_collective_id: destination.shippingRecordCollectiveId ?? '',
        shipping_date: destination.shippingDate,
        crop_id: destination.crop?.id ?? '',
        planting_id: destination.planting?.id ? destination.planting?.id : null,
        quality_standard_id: destination.qualityStandardId,
        quantity: destination.quantity,
        weight_unit_id: (destination.selectedWeightUnit?.id || destination.selectedWeightUnit?.id === null) ? destination.selectedWeightUnit.id : destination.weightUnitId,
        amount: destination.amount,
        unit_price: destination.unitPrice,
        memo: destination.memo,
        error_message: null
      }));
    const data: ShippingRecordCollectivePostModel = {
      isValidationNeeded: this.isValidationNeeded,
      shipping_destination_id: this.selectedDestination.id,
      shipping_record_collective: shippingrecordCollectiveDetails,
    }
    let method: "get" | "post" | "put" | "delete" = 'post'
    let url = this.apiBaseUrl
    let message = '保存しました。'
    if (this.mode == 'edit' || this.shippingChildId.length > 0) {
      method = 'put'
      url = `${this.apiBaseUrl}/shipping_records/${this.shippingChildId}`
      message = '変更を保存しました。'
      if (this.isValidationNeeded && !window.confirm("内容を上書きして保存します。よろしいですか。")) {
        return false
      }
    }
    return this.doRequest(method, url, data)
      .then((res) => {
        this.isCollectiveRecordSaved = true;
        this.$emit('update:isRefresh', true);
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if(res.length >0){
        this.$toasted.success(message);
        this.isSaveEditRecord = true
        this.isAgriFieldSave = false
        this.selectAll = false
        this.selectedItems = []
        this.selectedDays = []
        this.commaSeparatedNames = ""
        this.shippingRecordCollective.qualityStandards =[]
        this.selectedQualityStd =[]
        setTimeout(() => {
            const result = window.confirm('出荷記録まとめて一覧に戻りますか？');
            if (!result) {
               this.shippingChildId= res
               this.shippingRecordCollective.qualityStandards =[]
                this.getShippingRecordCollectiveRegisterdata(res);
                return false;
            }
            else{
             this.closeModal();
            }
        }, 400);
        this.isValidationNeeded = true;
      }else{
        alert("出荷記録を入力してください。");
      }
    })
  }

  openSplitShippingModal(resgiterCollectiveId: string) {
    this.shippingCollectiveRegisterId = resgiterCollectiveId;
    this.selectedCollectiveShippingDetails = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.find(item => item.shippingRecordCollectiveId === resgiterCollectiveId);
    this.showSplitShippingModal = true
  }

  getPlantingWeightUnitId() {
    this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map((cropPlanting, index) => {
      if (this.currentIndex === index) {
        const plantingId = cropPlanting.planting?.id;
        this.$apiClient.doRequest('get', `/plantings/${plantingId}`)
          .then((res) => {
            this.plantingBasicUnitId = res.basic_unit_id
            this.setDefaultWeightUnit();
          });
      }
    })
  }

  setDefaultWeightUnit() {
    const getWeightunit = this.weightUnits.find(item => item.id == this.plantingBasicUnitId && item.isHidden === false) ?? this.defaultWeightUnit;
    this.shippingRecordCollective.shippingRecordCollectiveDetailsItem?.forEach((destination, index) => {
      if (this.plantingBasicUnitId && !destination.selectedWeightUnit?.id && index === this.currentIndex && !destination.shippingRecordCollectiveId) {
        const prevState = { index, value: destination?.selectedWeightUnit?.name };
        const exWeightName = (prevState.index == index) ? getWeightunit?.name : prevState.value;
        const isKg = exWeightName == 'kg';
        destination.selectedWeightUnit = {
          id: isKg ? null : getWeightunit?.id || null,
          name: isKg ? 'kg' : getWeightunit?.name || 'kg',
          weightPerUnit: isKg ? 1 : getWeightunit?.weightPerUnit || null,
          isHidden: false
        };
      } else if (destination.selectedWeightUnit?.id && index === this.currentIndex && !destination.shippingRecordCollectiveId) {
        destination.selectedWeightUnit = {
          id: getWeightunit?.id || null,
          name: getWeightunit?.name || 'kg',
          weightPerUnit: getWeightunit?.weightPerUnit || null,
          isHidden: false
        };
      }
    });
  }

  private selectedRowIndex: number | null = null;
  private copiedRowData: any = null;
  private isCut = false as boolean
  private copiedRowIndex: number | null = null;
  private pastedRowIndex: number | null = null;
  private cutRowIndex: number | null = null;

  selectRow(isEditable: boolean, index: number) {
    if (isEditable) return false;
    if (this.selectedRowIndex !== null) {
        const previousRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (previousRowElement) {
            previousRowElement.classList.remove('selected-row');
        }
    }
    if (this.selectedRowIndex === index) {
        const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.remove('selected-row');
        }
        this.selectedRowIndex = null; 
    } else{
    this.selectedRowIndex = index; 
        const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${index + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.add('selected-row');
        }
    }
    if (this.copiedRowIndex === index ) {
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${index + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.remove('copied-row');
            currentRowElement.classList.add('selected-row');
        }
    }else{
      const currentRowElement = document.querySelector(
      `.table-c-data tbody tr:nth-child(${this.copiedRowIndex !== null ? this.copiedRowIndex + 1 : 0})`);
      if (currentRowElement) {
        currentRowElement.classList.remove('selected-row');
          currentRowElement.classList.add('copied-row');
      }
    }
    if (this.cutRowIndex === index ) {
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${index + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.remove('cuted-row');
            currentRowElement.classList.add('selected-row');
        }
    }else{
      const currentRowElement = document.querySelector(
      `.table-c-data tbody tr:nth-child(${this.cutRowIndex !== null ? this.cutRowIndex + 1 : 0})`);
      if (currentRowElement) {
        currentRowElement.classList.remove('selected-row');
          currentRowElement.classList.add('cuted-row');
      }
    }
    if(this.selectedRowIndex !=null){
      this.$store.dispatch('doUpdateIsInputChanged', true);
      this.isaddBtnFlag = true; 
      this.disableFieldFlag = true
      this.isDeleteBtnDisable =true
    }
    else{
      if(this.copiedRowData === null){
      this.isaddBtnFlag = false; 
      this.disableFieldFlag = false
      this.isDeleteBtnDisable =false
      this.$store.dispatch('doUpdateIsInputChanged', false);
      }
    }
  }

  copyRow() {
    if (this.selectedRowIndex !== null && this.copiedRowIndex == null && this.copiedRowData == null) {
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.add('copied-row');
      }
      this.copiedRowData = JSON.parse(JSON.stringify(this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[this.selectedRowIndex]));
      this.copiedRowIndex = this.selectedRowIndex;
      this.isCut = false;
      this.selectedRowIndex = null;
      this.cutRowIndex = null;
    }else if(this.copiedRowData !== null|| this.copiedRowIndex !==null){
      alert('すでに行をコピーしました。 コピーは無効になっています。');
    }
     else {
      alert('コピーする行を選択してください。');
    }
    this.inputChanged();
    this.isDeleteBtnDisable =true
    this.disableFieldFlag = true
  }

  cutRow() {
    if (this.selectedRowIndex !== null && this.copiedRowData === null && !this.isCut) {
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.add('cuted-row');
        }
      this.copiedRowData = JSON.parse(JSON.stringify(this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[this.selectedRowIndex]));
      this.cutRowIndex = this.selectedRowIndex;
      this.isCut = true;
      this.$nextTick(() => {
        const rowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.cutRowIndex && this.cutRowIndex + 1})`);
        if (rowElement) {
          rowElement.classList.add('cuted-row');
        }
      });
      this.selectedRowIndex = null;
      this.copiedRowIndex = null;
    } else if (this.copiedRowData !== null) {
      alert('すでに行をコピーしました。 カットは無効になっています。');
    } else {
      alert('カットする行を選択してください');
    }
    this.inputChanged();
    this.disableFieldFlag = true
    this.isDeleteBtnDisable =true
  }

  unselectRow(isEditable: boolean, index: number) {
    if (isEditable) return false;
    this.selectedRowIndex = index
    if(this.selectedRowIndex == this.copiedRowIndex){
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.remove('copied-row');
            currentRowElement.classList.remove('selected-row');
        }
      this.selectedRowIndex = null
      this.copiedRowData = null;
      this.copiedRowIndex = null;
      this.isaddBtnFlag = false
    }
    else if(this.selectedRowIndex == this.cutRowIndex){
      const currentRowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${this.selectedRowIndex + 1})`);
        if (currentRowElement) {
            currentRowElement.classList.remove('cuted-row');
            currentRowElement.classList.remove('selected-row');
        }
      this.selectedRowIndex = null
      this.cutRowIndex =null
      this.copiedRowData = null;
      this.isCut = false
      this.isaddBtnFlag = false
    }
    if(this.copiedRowData == null){
      this.disableFieldFlag = false
      this.isDeleteBtnDisable =false
    }
  }

  pasteRow() {
    if (this.copiedRowData) {
      const newRowData = JSON.parse(JSON.stringify(this.copiedRowData));
      if(this.copiedRowData !=null && !this.isCut){
      newRowData.errorMessage = "";
      newRowData.shippingRecordCollectiveId = "";
      newRowData.yetSplit = true;
      }
      const pasteIndex = this.selectedRowIndex !== null ? this.selectedRowIndex : 0;
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.splice(pasteIndex, 0, newRowData);
      if (this.isCut && this.cutRowIndex !== null) {
        const adjustedCutIndex = this.cutRowIndex < pasteIndex ? this.cutRowIndex : this.cutRowIndex + 1;
        this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.splice(adjustedCutIndex, 1);
        this.isCut = false;
      }
      this.copiedRowData = null;
      this.selectedRowIndex = null;
      this.copiedRowIndex = null;
      this.$nextTick(() => {
        this.pastedRowIndex = pasteIndex;
        const allRows = document.querySelectorAll('.table-c-data tbody tr');
      allRows.forEach(row => {
      row.classList.remove('cuted-row');
      row.classList.remove('copied-row');
      row.classList.remove('selected-row')
      });
        if (this.pastedRowIndex !== null) {
          let adjustedPastedRowIndex = this.pastedRowIndex;
        if (this.cutRowIndex !== null && this.pastedRowIndex > this.cutRowIndex) {
        adjustedPastedRowIndex--; 
        }
        this.cutRowIndex = null;
          const rowElement = document.querySelector(`.table-c-data tbody tr:nth-child(${adjustedPastedRowIndex + 1})`);
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            rowElement.classList.add('highlight');
            setTimeout(() => {
              rowElement.classList.remove('highlight');
            }, 1000);
            const inputs = rowElement.querySelectorAll('input, select') as NodeListOf<HTMLElement>;
          if (inputs.length > 1) {
             inputs[1].focus();
          }
          }
        }
      });
    this.isaddBtnFlag = false
    this.isDeleteBtnDisable =false
      this.inputChanged();
    } else {
      alert('ペーストする行データがありません。 1 行をコピーしてください。');
    }
  }

  isWeightPerUnit(detail: ShippingCollectiveDetailItem) {
    return detail.quantity && detail.selectedWeightUnit?.id && detail.selectedWeightUnit.weightPerUnit
  }

  private changeUnit(detail: ShippingCollectiveDetailItem) {
    const selectedWeightUnit = detail.selectedWeightUnit;
    if (selectedWeightUnit && selectedWeightUnit.id != null && selectedWeightUnit.weightPerUnit === null) {
      window.alert(`単位「${selectedWeightUnit.name}」の1単位あたりの重量を設定してください。`);
      detail.selectedWeightUnit = this.defaultWeightUnit;
      return;
    }
    this.calculateTotalAndRemaining()
    this.calculateTotalAndRemainingAmount()
    this.largeUnit()
    this.inputChanged()
  }

  calcAmount(detail: ShippingCollectiveDetailItem) {
    if (!this.isAutoCalc) {
      return false
    }
    if (!detail.quantity || !detail.unitPrice) {
      detail.amount = null
    } else {
      const calc = detail.quantity * detail.unitPrice
      detail.amount = Math.round(calc)
    }
    this.inputChanged()
  }
  calcUnitPrice(detail: ShippingCollectiveDetailItem) {
    if (!this.isAutoCalc) {
      return false;
    }
    if (!detail.quantity || detail.quantity == 0 || !detail.amount) {
      detail.unitPrice = null;
    } else {
      const unitPrice = detail.amount / detail.quantity;
      detail.unitPrice = Math.round(unitPrice * 100) / 100;
    }
    this.inputChanged()
  }

  calcQuantityPerWeight(detail: ShippingCollectiveDetailItem) {
    if (!detail.quantity || !detail.selectedWeightUnit?.id || !detail.selectedWeightUnit?.weightPerUnit) {
      return ''
    }
    const calc = detail.quantity * detail.selectedWeightUnit.weightPerUnit
    return Math.round(calc * 1000) / 1000
  }

  calcAmountPerWeight(detail: ShippingCollectiveDetailItem) {
    if (!detail.amount || !detail.selectedWeightUnit?.id || !detail.selectedWeightUnit?.weightPerUnit) {
      return ''
    }
    const quantity = this.calcQuantityPerWeight(detail)
    const calc = detail.amount / Number(quantity)
    return Math.round(calc * 100) / 100
  }

  openDestinationModal() {
    this.selectedDestinations = this.selectedDestination
    this.showDestinationModal = true
  }

  commitPlantingAndField(selectedItem: SelectCropAndPlantingInShippingRecord) {
    if (selectedItem.planting.id != null) {
      this.isSelectPlantingVisible = true
    }
    else {
      this.isSelectPlantingVisible = false
    }
    this.shippingRecordCollective.planting = {
      id: selectedItem.planting.id ?? '',
      name: selectedItem.planting.name
    }
    this.shippingRecordCollective.crop = {
      id: selectedItem.crop.id,
      name: selectedItem.crop.name,
      phonetic: selectedItem.crop.phonetic
    }
    if (this.shippingRecordCollective.crop.id != "" || this.shippingRecordCollective.planting.id != "") {
      this.isShippingTableDisable = false
    }
    else {
      this.isShippingTableDisable = true
    }
    if(this.shippingRecordCollective.planting.id !=null){
      this.getPlantingBasicUnitId();
      this.getPlantingAgrifelds();
   }
    this.inputChanged()
  }
private getPlantingAgrifelds(){
  this.$apiClient.doRequest('get', `/plantings/${this.shippingRecordCollective?.planting?.id}`)
  .then((res) => {
    this.plantingAgrifelds = res.agri_fields
  })}

  agriFieldSetAll() {
    if (this.selectAll) {
        this.selectedItems = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.filter(
            (item: any) => item.shippingRecordCollectiveId && !item.isShipped
        ).map(item => item.shippingRecordCollectiveId);
    } else {
        this.selectedItems = [];
    }
}

agriFieldSetBySingle(id: any, index: number) {
    const uniqueIdentifier = id || `temp-${index}`;
    const itemExists = this.selectedItems.includes(uniqueIdentifier);

    if (itemExists) {
        this.selectedItems = this.selectedItems.filter(
            (selectedId: any) => selectedId !== uniqueIdentifier
        );
    } else {
        this.selectedItems.push(uniqueIdentifier);
    }
    this.selectAll =
        this.selectedItems.length ===
        this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length;
}

saveAgrfieldDetails() { 
  let shippingCollectiveSplitDetails: any[] = [];
  if(this.selectedItems.length == 0 || this.selectedItems == null){
    alert("圃場設定するに行を選択してください。")
   return;
  }
  if (this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length > 0) {
    shippingCollectiveSplitDetails = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem
      .filter(item => item.shippingRecordCollectiveId)
      .map(item => ({
        shipping_date: item.shippingDate,
        shipping_destination_id: this.selectedDestination.id,
        shipping_record_collective_register_data_id: item.shippingRecordCollectiveId,
        crop_id: item.crop?.id,
        planting_id: item.planting?.id,
        agri_field_id: this.selectedItems.includes(item.shippingRecordCollectiveId) 
                        ? this.selectedAgriFieldId || null 
                        : null,
        quality_standard_id: item.qualityStandardId,
        quantity: item.quantity,
        weight_unit_id: item.selectedWeightUnit?.id ?? item.weightUnitId,
        amount: item.amount,
        unit_price: item.unitPrice,
        memo: item.memo,
        error_message: null,
      }));
  }
  const data = {
    shipping_record_collective: shippingCollectiveSplitDetails,
  };

this.$apiClient
  .doRequest('post', `/admin/collective_shipping_split/bulk_agri_field_insert`, data)
  .then(res => {
    if(res.length> 0) {
    this.isCollectiveRecordSaved = true;
    this.$emit('update:isRefresh', true);
    this.$store.dispatch('doUpdateIsInputChanged', false);
    const message = '変更を保存しました。'
    this.$toasted.success(message);
    this.selectedAgriFieldId =null
    this.selectedItems = [];
    this.selectAll = false;
    this.shippingChildId= res
    const nameList = this.commaSeparatedNames.split('::').map(name => name.trim());
    this.shippingRecordCollective.qualityStandards = this.qualityStandards.filter(item =>
      nameList.includes(item.name.trim())
    );
    this.selectedQualityStd = this.shippingRecordCollective.qualityStandards
    if(this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length != res.length){
      this.isSaveEditRecord = false
      this.disableFieldFlag = true
      this.isAgriFieldSave = true
    }else{
      this.disableFieldFlag = false
      this.isSaveEditRecord = false 
      this.isAgriFieldSave = false
    }
    this.getShippingRecordCollectiveRegisterdata(res);
    this.isValidationNeeded = true;
  }
  })
  .catch(err => {
      console.error(err);
  });
}

checkIfSelected(id:any) {
  return this.selectedItems.includes(id);
}

  commitPlantingAndFieldTable(selectedItem: SelectCropAndPlantingInShippingRecord) {
    const loggerCheck: ShippingCollectiveDetailItem[] = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map((item1, index) => {
      if (this.currentIndex === index) {
        return {
          ...item1,
          crop: selectedItem.crop ? {
            id: selectedItem.crop.id,
            name: selectedItem.crop.name,
            phonetic: ''
          } : null,
          splitPlantingId: null,
          splitPlantingName: null,
          planting: selectedItem.planting ? {
            id: selectedItem.planting.id || '',
            name: selectedItem.planting.name
          } : null
        };
      }
      return item1;
    });
    this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = loggerCheck
    this.getPlantingWeightUnitId();
    this.plantingDetailShowFlag = this.mode === "new" ? true : false
    this.disableFieldFlag = true
  }

  updateShippingDestination(shippingDestination: ShippingDestination) {
    if (this.shippingRecordCollective.shippingDestination.length) {
      this.shippingRecordCollective.shippingDestination.forEach(item => {
        if (item.id === shippingDestination.id) {
          item.name = shippingDestination.name
        }
      })
    }
  }

  commitDestinations(shippingDestinations: ShippingDestinations[]) {
    if (shippingDestinations) {
      this.selectedDestination = shippingDestinations
      // モーダルから返却されたもので更新する
      this.shippingRecordCollective.shippingDestination = shippingDestinations
    }
  }

  public async doRequest(method: "get" | "post" | "put" | "delete", url: string, params?: any) {
    const accessToken = store.getters.accsessToken
    const tenantId = this.$apiClient.getTenantId() || store.getters.tenantId;
    const config: AxiosRequestConfig = {
      url: `${this.apiServerBaseUrl}${url}`,
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
        'agri-tenant-id': tenantId
      },
      data: params,
      withCredentials: true
    }
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        await this.$apiClient.getAccessToken()
      }
      if (error.response.status === 400 && error.response.data?.message?.includes("保存しますか？")) {
        const result = window.confirm(error.response.data?.message)
        if (result) {
          this.isValidationNeeded = false;
          this.saveRecord();
        } else {
          this.isValidationNeeded = true;
          this.$toasted.success('保存がキャンセルされました。')
        }
        Promise.reject(error.response);
      } else {
        this.isValidationNeeded = true;
        this.$toasted.error('保存に失敗しました。');
        this.$apiClient.errorAlert(error.response.status, error.response.data?.message)
      }
      return Promise.reject(error.response)
    }
  }


  async getQualityStandards() {
    return this.$apiClient.doRequest('get', '/quality_standards?with_hidden=true')
      .then((res: QualityStandardResponse) => {
        this.qualityStandards = (toCamel(res) as QualityStandards).qualityStandards
      })
      .catch(() => {
        this.$toasted.error('データの取得に失敗しました。')
      })
  }

  getWeightUnit(id: string) {
    if (!id) {
      return this.defaultWeightUnit
    }
    const unit = this.weightUnits.find(unit => unit.id == id)
    return unit ? unit : this.defaultWeightUnit
  }

  async getWeightUnits() {
    return this.$apiClient.doRequest('get', '/weight_units?with_hidden=true')
      .then((res: WeightUnitResponse) => {
        this.weightUnits = (toCamel(res) as WeightUnits).weightUnits
      })
      .catch(() => {
        this.$toasted.error('データの取得に失敗しました。')
      })
  }

  async getShippingRecordCollectiveRegisterdata(ids: any) {
    let idString;
    if (typeof ids === "string") {
      idString = ids.split('、').join(',');
    }
    else if (Array.isArray(ids)) {
      idString = ids.map((item: any) => item.id || item).join(',');
    }
    this.$apiClient.doRequest('get', `${this.apiBaseUrl}/shipping_records/${idString}`)
      .then((res) => {
          const newShippingRecordCollective = toCamel(res) as ShippingRecordCollectiveRegisterItem;
          if (newShippingRecordCollective) {
            const existingDetails = this.shippingRecordCollective?.shippingRecordCollectiveDetailsItem || [];
            if (this.isAgriFieldSave === true) {
              const mergedDetails = [
                ...existingDetails,
                ...newShippingRecordCollective.shippingRecordCollectiveDetailsItem.filter(
                  newItem => !existingDetails.some(existing => existing.shippingRecordCollectiveId === newItem.shippingRecordCollectiveId)
                )
              ];
              this.shippingRecordCollective = {
                ...this.shippingRecordCollective,
                ...newShippingRecordCollective,
                shippingRecordCollectiveDetailsItem: mergedDetails
              };
            }
            else{
              this.shippingRecordCollective = newShippingRecordCollective
            }
          const destinationId = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[0]?.shippingDestinationId;
          this.shippingRecordCollective.shippingDestination = this.shippingDestinationList.filter(item => destinationId === item.id);
          this.selectedDestination = this.shippingDestinationList?.find(item => destinationId === item.id);
          if (this.isAgriFieldSave === false) {
          this.disableFieldFlag = false;
          }
          this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.forEach(destination => {
            destination.selectedWeightUnit = destination.weightUnitId
              ? this.getWeightUnit(destination.weightUnitId)
              : this.defaultWeightUnit;
          });
          const loggerCheck: ShippingCollectiveDetailItem[] = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map((item1: any) => {
            return {
              ...item1,
              crop: {
                id: item1?.cropId ? item1?.cropId : item1.crop.id,
                name: item1.cropName ? item1.cropName : item1.crop.name,
                phonetic: ''
              },
              planting: {
                id: item1.plantingId || item1.planting?.id || "",
                name: item1.plantingName || item1.planting?.name || ""
              }
            };
          });
          this.shippingChildId = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map(item => item.shippingRecordCollectiveId);
          // Check if res.shippingRecordCollectiveDetailsItem exists
          if (res.shippingRecordCollectiveDetailsItem && res.shippingRecordCollectiveDetailsItem.length > 0) {
            const cropId = res.shippingRecordCollectiveDetailsItem[0].crop_id;
            const plantingId = res.shippingRecordCollectiveDetailsItem[0].planting_id;

            if (this.shippingRecordCollective.shippingRecordCollectiveDetailsItem && this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length === 1) {
              this.$set(this.shippingRecordCollective, 'crop', {
                id: res.shippingRecordCollectiveDetailsItem[0].crop_id ?? '',
                name: res.shippingRecordCollectiveDetailsItem[0].crop_name ?? '',
                phonetic: ""
              });
              this.$set(this.shippingRecordCollective, 'planting', {
                id: res.shippingRecordCollectiveDetailsItem[0].planting_id ?? '',
                name: res.shippingRecordCollectiveDetailsItem[0].planting_name ?? ''
              });
            }
            else {
              const allPlantingIdsMatch = res.shippingRecordCollectiveDetailsItem.every((item1: any) => {
                return item1?.planting_id === plantingId
              }
              );

              if (allPlantingIdsMatch) {
                this.$set(this.shippingRecordCollective, 'crop', {
                  id: res.shippingRecordCollectiveDetailsItem[0].crop_id ?? '',
                  name: res.shippingRecordCollectiveDetailsItem[0].crop_name ?? '',
                  phonetic: ""
                });
                this.$set(this.shippingRecordCollective, 'planting', {
                  id: res.shippingRecordCollectiveDetailsItem[0].planting_id ?? '',
                  name: res.shippingRecordCollectiveDetailsItem[0].planting_name ?? ''
                });
              } else {
                this.$set(this.shippingRecordCollective, 'crop', {
                  id: res.shippingRecordCollectiveDetailsItem[0].crop_id ?? '',
                  name: res.shippingRecordCollectiveDetailsItem[0].crop_name ?? '',
                  phonetic: ""
                });
                this.$set(this.shippingRecordCollective, 'planting', {
                  id: '',
                  name: ''
                });
              }
            }
          }
          // Set visibility based on plantingId
          if (this.shippingRecordCollective.planting?.id === '') {
            this.selectedAgriFieldId =null
            this.isSelectPlantingVisible = false;
          } else {
            this.getPlantingBasicUnitId();
            this.selectedAgriFieldId =null
            this.getPlantingAgrifelds();
            this.isSelectPlantingVisible = true;
          }
          this.isShippingTableDisable = false
          this.plantingDetailShowFlag = false
          this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = loggerCheck
        }
      })
      .catch((error) => {
        console.error('Request failed', error);
      });
  }

  getPlantingBasicUnitId(){
      this.$apiClient.doRequest('get', `/plantings/${this.shippingRecordCollective.planting?.id}`)
      .then((res) => {
        this.plantingBasicUnitId = res.basic_unit_id
      });
  }

  getShippingDestination() {
    this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
      this.shippingDestinationList = ret.shipping_destinations;
    })
  }
  private openPlantingShippingModal(flag: boolean) {
    if (this.selectedDestination) {
      this.selectedShippingTarget.cropId = this.shippingRecordCollective.crop ? this.shippingRecordCollective.crop.id : null
      this.selectedShippingTarget.plantingId = this.shippingRecordCollective.planting ? this.shippingRecordCollective.planting.id : null
      this.showSelectFromPlantingShipping = true
    }
    else {
      this.validation();
    }
  }

  validation(): boolean {
    const errmsg: string[] = []
    // 出荷先
    if (this.shippingRecordCollective.shippingDestination == null || this.shippingRecordCollective.shippingDestination.length == 0) {
      errmsg.push('出荷先を選択してください')
    } else {
      if (this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length == 0) {
        errmsg.push("出荷記録を入力してください。")
      } else {
        this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.map((detail, index) => {
          const detailIndex = index + 1
          if (
            detail.qualityStandardId || 
            detail.quantity || 
            detail.amount || 
            detail.unitPrice || 
            detail.memo
          ) {
            if (!detail.isShipped) {
              if (detail.shippingDate === "" || detail.shippingDate === null) {
                errmsg.push(`${detailIndex}行目:出荷日を選択してください`)
              }
              if (detail.quantity || detail.amount || detail.unitPrice || detail.memo) {
                if (detail.crop?.id === "" || detail.crop?.id === null) {
                  errmsg.push(`${detailIndex}行目:作目を選択してください`)
                }
                if (detail.qualityStandardId === "" || detail.qualityStandardId === null) {
                  errmsg.push(`${detailIndex}行目:出荷(品質・規格)を選択してください`)
                }
                if (detail.quantity == null || detail.quantity.toString() == '') {
                  errmsg.push(`${detailIndex}行目:数量を入力してください`)
                } else if (detail.quantity == 0) {
                  errmsg.push(`${detailIndex}行目:数量を0より大きい数値を入力してください`)
                } else {
                  const quantityStr = detail.quantity.toString().split('.')
                  if (detail.quantity < 0 || quantityStr[0].length > 7 || (quantityStr[1] && quantityStr[1].length > 2)
                  ) {
                    errmsg.push(`${detailIndex}行目:数量は0以上の整数部7桁小数部2桁までの数値を入力してください`)
                  }
                }
                if (detail.amount && (detail.amount < 0 || !Number.isInteger(Number(detail.amount)))) {
                  errmsg.push(`${detailIndex}行目:金額は0以上の整数を入力してください`)
                }
                if (detail.unitPrice) {
                  const unitStr = detail.unitPrice.toString().split('.')
                  if (detail.unitPrice < 0 || unitStr[0].length > 7 || (unitStr[1] && unitStr[1].length > 2)) {
                    errmsg.push(`${detailIndex}行目:単価は0以上の整数部7桁小数部2桁までの数値を入力してください`)
                  }
                }
                if (detail.memo && detail.memo.length > 21844) {
                  errmsg.push(`${detailIndex}行目:備考は21844文字以内で入力してください（現在は${detail.memo.length}文字）`)
                }
              }
            }
          }
        })
      }
    }
    if (errmsg.length > 0) {
      window.alert(errmsg.join('\n'))
      return false
    }
    return true
  }

  private openRecordPlantingShippingModal(index: number) {
    this.currentIndex = index;
    const detailItem = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem?.[this.currentIndex];
    this.selectedTableShippingTarget.cropId = detailItem?.crop?.id ?? null;
    this.selectedTableShippingTarget.plantingId = detailItem?.planting?.id
    ? detailItem.planting.id
    : detailItem?.splitPlantingId 
        ? detailItem.splitPlantingId
        : null;
    this.showSelectTablePlantingShipping = true;
    if(this.mode === "new" && this.isShippingTableDisable){
      this.plantingDetailShowFlag = true
    }
    else{
      this.plantingDetailShowFlag = false
    }
  }

  closeModal() {
    if(this.selectedDays?.length || this.shippingRecordCollective.qualityStandards?.length > 0 || this.selectedItems.length >0 || (this.isSaveEditRecord === false && this.isAgriFieldSave === true)){
      store.dispatch("doUpdateIsInputChanged", true);
    }
    if (store.getters.isInputChanged) {
      const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
      if (confirm) {
        store.dispatch("doUpdateIsInputChanged", false);
        this.$emit('update:isShow', false);
        this.$emit('update:showShippingCollectiveRegister', false);
        this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = [];
        this.shippingChildId = []
        this.pastedRowIndex = null
        this.selectedRowIndex = null
        this.copiedRowIndex = null
        this.copiedRowData = null
        this.cutRowIndex = null
        this.isCut = false
        this.plantingBasicUnitId =null
        this.selectedDestinations = []
        this.selectedDestination = null
        this.shippingRecordCollective.crop = null;
        this.shippingRecordCollective.planting = null;
        this.shippingRecordCollective.shippingDestination = []
        this.isSelectPlantingVisible = false
        this.isShippingTableDisable = true
        this.plantingDetailShowFlag = true
        this.isSaveEditRecord = false
        this.disableFieldFlag = false
        this.isDeleteBtnDisable =false
        this.isaddBtnFlag = false
        this.currentIndex = 0
        this.shippingRecordCollective.qualityStandards =[]
        this.selectedQualityStd =[]
        this.selectedDays = [];
        this.selectedItems =[];
        this.commaSeparatedNames ="";
        this.selectAll =false;
        this.selectedItems = [];
        this.selectedAgriFieldId =null
        this.selectedStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      }
    }else{
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = [];
      this.shippingChildId = []
      this.pastedRowIndex = null
      this.selectedRowIndex = null
      this.copiedRowIndex = null
      this.copiedRowData = null
      this.cutRowIndex = null
      this.isCut = false
      this.selectedDestinations = []
      this.selectedDestination = null
      this.shippingRecordCollective.crop = null;
      this.shippingRecordCollective.planting = null;
      this.shippingRecordCollective.shippingDestination = []
      this.isSelectPlantingVisible = false
      this.isShippingTableDisable = true
      this.plantingDetailShowFlag = true
      this.isSaveEditRecord = false
      this.disableFieldFlag = false
      this.isDeleteBtnDisable =false
      this.isaddBtnFlag = false
      this.currentIndex = 0
      this.shippingRecordCollective.qualityStandards =[]
      this.selectedQualityStd =[]
      this.selectedDays = [];
      this.commaSeparatedNames ="";
      this.selectedItems =[];
      this.selectAll =false;
      this.selectedAgriFieldId =null
      this.selectedStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      this.selectedEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      this.$emit('update:showShippingCollectiveRegister', false);
      store.dispatch("doUpdateIsInputChanged", false);
    }
    if (this.isCollectiveRecordSaved === true) {
      this.$emit('update:isRefresh', true);
    }
  }

  cancelRecord() {
    if(this.selectedDays?.length || this.shippingRecordCollective.qualityStandards?.length > 0 || this.selectedItems.length >0 || (this.isSaveEditRecord === false && this.isAgriFieldSave === true)){
      store.dispatch("doUpdateIsInputChanged", true);
    }
    if (this.$store.getters.isInputChanged) {
      const result = window.confirm('変更内容を破棄します。よろしいですか。');
      if (!result) {
        return false;
      } else {
        this.disableFieldFlag = false
        this.copiedRowIndex = null
        this.cutRowIndex = null
        this.selectedRowIndex = null
        this.copiedRowData = null;
        this.isCut = false
        this.isShippingTableDisable = true
        this.isaddBtnFlag = false
        this.isDeleteBtnDisable =false
        const allRows = document.querySelectorAll('.table-c-data tbody tr');
        allRows.forEach(row => {
          row.classList.remove('cuted-row');
          row.classList.remove('copied-row');
          row.classList.remove('selected-row')
        });
        this.isDeleteBtnDisable =false
        this.selectedDays = [];
        this.commaSeparatedNames ="";
        this.selectedItems =[]
        this.selectAll = false
        this.selectedAgriFieldId =null
        this.shippingRecordCollective.qualityStandards = []
        this.selectedQualityStd =[]
        this.selectedStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        this.isAgriFieldSave = false
      }
    }
    this.$store.dispatch('doUpdateIsInputChanged', false);
    if (this.shippingChildId.length>0) {
      this.getShippingRecordCollectiveRegisterdata(this.shippingChildId);
    } else {
      this.copiedRowIndex = null
      this.cutRowIndex = null
      this.selectedRowIndex = null
      this.copiedRowData = null
      this.selectedDestination = null
      this.isCut = false
      this.isaddBtnFlag = false
      this.selectedDestinations = []
      this.shippingRecordCollective.shippingRecordCollectiveDetailsItem = []
      this.shippingRecordCollective.shippingDestination = []
      this.shippingRecordCollective.crop = null
      this.shippingRecordCollective.planting = null
      this.disableFieldFlag = false
      this.isDeleteBtnDisable =false
      this.selectedDays = [];
      this.commaSeparatedNames ="";
      this.selectedItems =[]
      this.selectAll = false
      this.selectedAgriFieldId =null
      this.selectedStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      this.selectedEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      this.shippingRecordCollective.qualityStandards = []
      this.selectedQualityStd =[]
    }
  }

  @Emit('inputChanged')
  private inputChanged() {
    if (store.getters.isInputChanged == false) {
      this.$store.dispatch('doUpdateIsInputChanged', true);
       this.disableFieldFlag = true
    }
  }

  private filterQualityStandardsByDetail(detail: ShippingCollectiveDetailItem) {
    return this.qualityStandards
      .filter(qs => detail.qualityStandardId == qs.id || qs.isHidden === false)
  }

  private filterWeightUnitsByDetail(detail: ShippingCollectiveDetailItem) {
    const selectedWeightUnit = detail.selectedWeightUnit;
    return this.weightUnits.filter(wu => (selectedWeightUnit?.id == wu.id || detail.weightUnitId == wu.id) || wu.isHidden === false)
  }

  closeShippingSplitModal() {
    this.shippingCollectiveRegisterId = ''
    this.showSplitShippingModal = false
  }

  changeMemo() {
    this.inputChanged()
  }

  changeAgrifield(){
    this.$store.dispatch('doUpdateIsInputChanged', true);
  }

calculateTotalAndRemaining() {
  const result = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.reduce(
    (acc: Record<string, { total: number, remainingTotal: number, unitName: string }>, detail: any) => {
      const quantity = Number(detail.quantity) || 0; // Total quantity
      const remainingQuantity = detail.isShipped === false  ? quantity: !isNaN(detail.remainingQuantity) ? Number(detail.remainingQuantity) : 0;
      const { id: unitId, name: unitName } = detail.selectedWeightUnit;
      if (!acc[unitId]) {
        acc[unitId] = { total: 0, remainingTotal: 0, unitName };
      }
      acc[unitId].total = parseFloat((acc[unitId].total + quantity).toFixed(2));
      acc[unitId].remainingTotal = parseFloat((acc[unitId].remainingTotal + remainingQuantity).toFixed(2));
      return acc;
    },
    {} as Record<string, { total: number, remainingTotal: number, unitName: string }>
  );
  const output= Object.values(result)
    .map(item => {
      const truncatedUnitName = item.unitName.length > 8 ? item.unitName.substring(0, 8) : item.unitName;
      return `${item.total.toLocaleString('ja-jp')}${truncatedUnitName} (${item.remainingTotal.toLocaleString('ja-jp')})`;
    })
    .join(', ');

  const allZero = Object.values(result).every(item => {
    item.total === 0
   });
  return allZero ? `--- (---)` : `${output}`;
}

calculateTotalAndRemainingAmount() {
  const result = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.reduce(
    (acc: { total: number; remainingTotal: number }, detail: any) => {
      const amount = Number(detail.amount) || 0
      const remainingAmount = detail.isShipped === false 
        ? amount
        : !isNaN(detail.remainingQuantity) 
            ? Number(detail.remainingQuantity * detail.unitPrice) 
            : 0;
      acc.total += amount;
      acc.remainingTotal += remainingAmount;
      return acc;
    },
    { total: 0, remainingTotal: 0 }
  );
  const totalFormatted = result.total === 0 ? "---" : Math.round(result.total).toLocaleString('ja-JP') + '円';
  const remainingFormatted = result.remainingTotal === 0 ? "---" : Math.round(result.remainingTotal).toLocaleString('ja-JP') + '円';
  return `${totalFormatted} (${remainingFormatted})`;
}

private getDayClass(date: string): string {
  if (!date) return '';
  const selectedDate = new Date(date);
  const dayOfWeek = selectedDate.getDay();
  if (dayOfWeek === 0) {
    return 'sunday';
  } else if (dayOfWeek === 6) {
    return 'saturday';
  } else {
    return 'weekday';
  }
}

handleInputClick(inputType: string) {
  this.activeInput = inputType;
}

handleArrowKeys(event: KeyboardEvent, index: number) {
  // if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
  //   event.preventDefault();
  // }

  const isShippedArray: boolean[] = [];

  const inputOrder = [
    'dateInput',
    'cropInput',
    'plantingInput',
    'qualityStandardInput',
    'quantityInput',
    'weightUnitInput',
    'amountInput',
    'unitPriceInput',
    'memoInput',
  ];

  const currentInputIndex = inputOrder.indexOf(this.activeInput);

  if (currentInputIndex === -1) {
    return;
  }

  const inputs = this.$refs as { [key: string]: HTMLInputElement | HTMLInputElement[] | HTMLSelectElement | HTMLSelectElement[] };

  this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.forEach((item, idx) => {
    isShippedArray[idx] = item.isShipped;
  });

  const shouldSkipInput = (inputIndex: number, detailIndex: number): boolean => {
    const inputPrefix = inputOrder[inputIndex];
    if (inputPrefix === 'cropInput') {
      return !this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[detailIndex]?.crop?.id;
    } else if (inputPrefix === 'plantingInput') {
      return !this.shippingRecordCollective.shippingRecordCollectiveDetailsItem[detailIndex]?.planting?.id;
    }
    return false;
  };

  if (event.key === 'ArrowUp') {
    let prevIndex = index - 1;
    while (prevIndex >= 0 && isShippedArray[prevIndex]) {
      prevIndex--;
    }
    if (prevIndex >= 0) {
      const previousInput = inputs[`${this.activeInput}-${prevIndex}`];
      const previousInputElement = Array.isArray(previousInput) ? previousInput[0] : previousInput;
      if (previousInputElement instanceof HTMLInputElement || previousInputElement instanceof HTMLSelectElement) {
        previousInputElement.focus();
      }
    }
  } else if (event.key === 'ArrowDown') {
    let nextIndex = index + 1;
    while (nextIndex < this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length && isShippedArray[nextIndex]) {
      nextIndex++;
    }
    if (nextIndex < this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.length) {
      const nextInput = inputs[`${this.activeInput}-${nextIndex}`];
      const nextInputElement = Array.isArray(nextInput) ? nextInput[0] : nextInput;
      if (nextInputElement instanceof HTMLInputElement || nextInputElement instanceof HTMLSelectElement) {
        nextInputElement.focus();
      }
    }
  } else if (event.key === 'ArrowLeft') {
    if (currentInputIndex > 0) {
      let prevInputIndex = currentInputIndex - 1;
      while (prevInputIndex >= 0 && (this.isInputDisabled(prevInputIndex, index) || shouldSkipInput(prevInputIndex, index))) {
        prevInputIndex--;
      }
      if (prevInputIndex >= 0) {
        const previousInputPrefix = inputOrder[prevInputIndex];
        const previousInput = inputs[`${previousInputPrefix}-${index}`];
        const previousInputElement = Array.isArray(previousInput) ? previousInput[0] : previousInput;
        if (previousInputElement instanceof HTMLInputElement || previousInputElement instanceof HTMLSelectElement) {
          previousInputElement.focus();
          this.activeInput = previousInputPrefix;
        }
      }
    }
  } else if (event.key === 'ArrowRight') {
    if (currentInputIndex < inputOrder.length - 1) {
      let nextInputIndex = currentInputIndex + 1;
      while (nextInputIndex < inputOrder.length && (this.isInputDisabled(nextInputIndex, index) || shouldSkipInput(nextInputIndex, index))) {
        nextInputIndex++;
      }
      if (nextInputIndex < inputOrder.length) {
        const nextInputPrefix = inputOrder[nextInputIndex];
        const nextInput = inputs[`${nextInputPrefix}-${index}`];
        const nextInputElement = Array.isArray(nextInput) ? nextInput[0] : nextInput;
        if (nextInputElement instanceof HTMLInputElement || nextInputElement instanceof HTMLSelectElement) {
          nextInputElement.focus();
          this.activeInput = nextInputPrefix;
        }
      }
    }
  }
}

isInputDisabled(inputIndex: number, index: number): boolean {
  const inputOrder = [
    'dateInput',
    'cropInput',
    'plantingInput',
    'qualityStandardInput',
    'quantityInput',
    'weightUnitInput',
    'amountInput',
    'unitPriceInput',
    'memoInput',
  ];

  const inputPrefix = inputOrder[inputIndex];
  const input = this.$refs[`${inputPrefix}-${index}`];

  const inputElement = Array.isArray(input) ? input[0] : input;
  if (inputElement instanceof HTMLInputElement || inputElement instanceof HTMLSelectElement) {
    return inputElement.disabled;
  }

  return false;
}

largeUnit() {
  const result = this.shippingRecordCollective.shippingRecordCollectiveDetailsItem.reduce(
    (acc: Record<string, { total: number, remainingTotal: number, unitName: string }>, detail: any) => {
      const quantity = Number(detail.quantity) || 0; // Total quantity
      const remainingQuantity = detail.isShipped === false  ? quantity: !isNaN(detail.remainingQuantity) ? Number(detail.remainingQuantity) : 0;
      const { id: unitId, name: unitName } = detail.selectedWeightUnit;
      if (!acc[unitId]) {
        acc[unitId] = { total: 0, remainingTotal: 0, unitName };
      }
      acc[unitId].total = parseFloat((acc[unitId].total + quantity).toFixed(2));
      acc[unitId].remainingTotal = parseFloat((acc[unitId].remainingTotal + remainingQuantity).toFixed(2));
      return acc;
    },
    {} as Record<string, { total: number, remainingTotal: number, unitName: string }>
  );
  const output= Object.values(result)
    .map(item => {
      return `${item.total.toLocaleString('ja-jp')}${item.unitName} (${item.remainingTotal.toLocaleString('ja-jp')})`;
    })
    .join(', ');

  const allZero = Object.values(result).every(item => {
    item.total === 0
   });
  return allZero ? `--- (---)` : `${output}`;
}

disabledDateButton(){
if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate !== '') || (this.selectedStartDate === '' && this.selectedEndDate === '')) {
  this.isButtonDisabled = true;
}else{
  this.checkByDay()
  this.isButtonDisabled = false;
}
}

dateNavigation(action: string) {
  if (!this.selectedStartDate || !this.selectedEndDate) return;
  this.validateDates()
  if(this.isButtonDisabled == false){
  const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
  const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
  const offset = (action === 'previous') ? -daysDifference : daysDifference;
  this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
  this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
  this.checkByDay()
  }
  else{
    this.isButtonDisabled = false;
  }
  } 
validateDates() {
  if (!this.selectedStartDate || !this.selectedEndDate) return;
  if (this.selectedStartDate > this.selectedEndDate) {
    this.isButtonDisabled = true;
  } else{
    this.isButtonDisabled = false;
  }
}

formatDigit(input :string){
  const  roundedQuantity = parseFloat(Number(input).toFixed(2));
  return roundedQuantity?.toLocaleString("ja-jp")
}

}

